import React from 'react';
import { motion } from 'framer-motion';

const commitmentsData = [
  {
    id: 1,
    title: "Net zero Initiative",
    desc: "leading the charge towards a net zero emissions future by 2035"
  },
  {
    id: 2,
    title: "Water Positive Promise",
    desc: "Optimizing water resources and implementing harvesting models across global supply channels."
  },
  {
    id: 3,
    title: "Zero waste to landfill certification",
    desc: "Ensuring 100% material recycling and sustainable waste reduction methodologies."
  },
  {
    id: 4,
    title: "Renewable Energy Transition",
    desc: "Powering infrastructure with fully sustainable, green, and renewable power sources."
  }
];

const OurCommitments = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <section className="w-full bg-[#FFFFFF] py-16 lg:py-24 overflow-hidden select-none text-left">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

        <div className="w-full text-center mb-16">
          <h2
            className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora"
          >
            Our Commitments
          </h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-end w-full overflow-hidden"
        >
          {commitmentsData.map((tab) => (
            <motion.div
              key={tab.id}
              variants={itemVariants}
              className="w-full h-[220px] bg-white border border-[#01386A45] border-b-0 flex flex-col justify-center group cursor-pointer transition-all duration-500 ease-out hover:h-[260px] hover:bg-[#002D62] hover:justify-between p-6 lg:p-8 relative"
            >
              <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />

              <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#EA580C] z-20 transition-all duration-500 ease-out group-hover:w-full" />

              <div className="w-full flex flex-col items-start transition-all duration-500 group-hover:mt-2 relative z-30">
                <h3
                  className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-snug transition-colors duration-300 group-hover:text-white"
                >
                  {tab.title}
                </h3>
              </div>

              <div className="w-full opacity-0 max-h-0 overflow-hidden group-hover:opacity-100 group-hover:max-h-20 group-hover:mt-auto transition-all duration-500 ease-out relative z-30">
                <p
                  className="text-[#FFFFFF] text-[14px] sm:text-[16px] font-graphik leading-relaxed font-[500] group-hover:text-white/90"
                >
                  {tab.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default OurCommitments;